module.exports = __webpack_public_path__ + "static/media/fenxiang2.02a2ea33.png";